import { useMemo } from "react";
import { Card, Grid } from "@mui/material";
import { Autocomplete, Box, ColorPicker, Typography } from "@maysoft/common-component-react";

import Header from "./header";
import useStrings from "../../hooks/useStrings";
import { Mode } from "../../constants/enums";
import { container, typography } from "./styles";
import { ICodename, ICommunity } from "../../commons/interfaces";
import { ICommunityError } from "../../hooks/community/edit/useData";

interface IProps {
    mode: Mode;
    data: ICommunity;
    error: ICommunityError;
    fontData: ICodename[];
    onChangeValue: (value: string, key: keyof ICommunity["setting"]) => void;
}

const Appearance: React.FC<IProps> = ({ mode, data, error, fontData, onChangeValue }) => {
    const Strings = useStrings();
    const fontFamily = useMemo(() => data?.setting.font, [data.setting]);
    return (
        <Card>
            <Box p={2} sx={container}>
                <Header title={Strings.COMMUNITY.APPEARANCE} description={""} />
                <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                        <ColorPicker
                            mode={mode}
                            label={Strings.COMMUNITY.PRIMARY_COLOR}
                            description={Strings.COMMUNITY.PRIMARY_COLOR_DESC}
                            value={data.setting.primaryColor}
                            onChangeValue={(value) => onChangeValue(value, "primaryColor")}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={4}>
                        <Autocomplete
                            required
                            isSelectedBox
                            mode={mode}
                            data={fontData || []}
                            defaultValue={data?.setting.font}
                            label={Strings.COMMUNITY.FONT}
                            placeholder={Strings.COMMUNITY.SELECT_FONT}
                            onChange={(value) => onChangeValue(value, "font")}
                        />
                    </Grid>
                    <Grid item xs={12} md={10} lg={8}>
                        <Box
                            sx={{
                                border: "1px solid #d3d3d3",
                                px: 3,
                                py: 2,
                            }}
                        >
                            <Typography variant="h3" sx={(theme) => typography(theme, { fontSize: "2rem", fontWeight: 700, fontFamily })}>
                                Title
                            </Typography>
                            <Typography sx={(theme) => typography(theme, { fontFamily })}>
                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis
                                natoque penatibus et magnis dis parturient montes.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    );
};

export default Appearance;
